export default () => (
  <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="52.5216"
      y="39.7758"
      width="13.3669"
      height="35.645"
      rx="6.68343"
      transform="rotate(120 52.5216 39.7758)"
      fill="#8FB4FF"
      stroke="white"
      strokeWidth="2.22781"
    />
    <rect
      x="24.2884"
      y="15.6775"
      width="13.3669"
      height="35.645"
      rx="6.68343"
      fill="#8FB4FF"
      stroke="white"
      strokeWidth="2.22781"
    />
  </svg>
)
